import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});

export const driverLoginSchema = z.object({
  dni: z.string().min(1).max(20),
  password: z.string().min(8),
});

export const tokenPayloadSchema = z.object({
  sub: z.string().uuid(),
  email: z.string().email(),
  role: z.enum(["admin", "operator", "fleet_manager", "driver"]),
  sessionId: z.string().uuid(),
  isSuperAdmin: z.boolean().optional(),
  iat: z.number(),
  exp: z.number(),
});

export type LoginInput       = z.infer<typeof loginSchema>;
export type DriverLoginInput = z.infer<typeof driverLoginSchema>;
export type TokenPayload     = z.infer<typeof tokenPayloadSchema>;
